// Backend ke "LLM" endpoints (getLlmDetails, update-llm, llmprompt…) ke liye
// agent ka ID.
//   Retell LLM agent          → llmId (pehle jaisa)
//   Conversation flow agent   → agent_id (llmId nahi hota; backend "agent_…" ID
//                               dekh ke flow padhta / badalta hai)
//   Python agent (koi Retell LLM / flow nahi) → "" — callers pehle jaisa skip karein
export const getAgentEngineId = (agent) => {
  if (!agent) return "";
  const llmId = agent.llmId || agent.llm_id;
  if (llmId) return llmId;
  if (agent.responseEngineType === "conversation-flow") {
    return agent.agent_id || agent.agentId || "";
  }
  return "";
};
